<template>
  <main id="holiday-periods-main">
    <div class="app-view-container">
      <el-row>
        <el-col class="app-view-title">
          {{ $t('admin.holidayPeriods.title') }}
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <search-filter ref="searchFilter"/>
        </el-col>
      </el-row>

      <el-row class="search-summary-container bg-white">
        <el-col>
          <el-row class="default-section-header">
            <el-col :span="6" class="default-section-title">
              {{ $t('admin.holidayPeriods.summaryTitle') }}
              <el-tooltip class="item" effect="dark" :enterable="false" :content="$t('common.refresh')" placement="top-start">
                <el-button @click="handleRefresh" icon="el-icon-refresh" size="mini" class="button-action-default search-summary-refresh-button"></el-button>
              </el-tooltip>
            </el-col>
            <el-col :span="18" class="default-section-actions text-align-end">
              <add-holiday-period />
            </el-col>
          </el-row>
          <el-row class="search-summary">
            <el-col>
              <search-summary />
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
  </main>
</template>

<script>
import { mapGetters } from 'vuex';
import AddHolidayPeriod from '@/views/admin/holidayPeriods/components/AddHolidayPeriod';
import selectService from '@/api/selectService';
import apiConstants from '@/utils/apiConstants';
import SearchFilter from './SearchFilter';
import SearchSummary from './SearchSummary';

export default {
  name: 'HolidayPeriods',
  components: {
    AddHolidayPeriod,
    SearchFilter,
    SearchSummary
  },
  computed: {
    ...mapGetters(['holidayPeriods']),
  },
  methods: {
    handleRefresh() {
      this.$refs.searchFilter.handleSearch();
    }
  },
  mounted() {
    selectService.getList(apiConstants.END_POINTS.ACCOUNTS.DAYS_OF_SERVICE.MANAGEMENT.REGION).then(response => {
      this.$store.dispatch('holidayPeriods/setRegions', response.data);
    });
  },
};
</script>
